
import { FolderOpen, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

export function EmptyDrawingState() {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center border-2 border-dashed border-border/40 rounded-xl bg-muted/10">
      <div className="bg-muted/30 p-4 rounded-full mb-4">
        <FolderOpen className="h-10 w-10 text-muted-foreground/60" />
      </div>
      <h3 className="text-lg font-medium text-foreground/80 mb-1">No drawings found</h3>
      <p className="text-sm text-muted-foreground max-w-md mb-4">
        Create a new drawing or try different search filters to find your drawings.
      </p>
      <Button className="bg-primary/90 hover:bg-primary flex items-center gap-2">
        <Plus className="h-4 w-4" />
        Create New Drawing
      </Button>
    </div>
  );
}
